import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonItem, IonList, IonSpinner, IonText } from "@ionic/react";
import { StudentEnrollmentFromServer, StudentStatusFromServer } from "../../../data-types/Types";
import { useData } from "../services/DataProvider";
import { formatAssignmentWindow, getAssignmentAvailability } from "../utils/assignmentAvailability";

const ClassOverview:React.FC<{studentEnrollment: StudentEnrollmentFromServer}> = ({studentEnrollment, ...props})=>{
  //const link = (window.location.port === "443"? "https://": "http://") + window.location.hostname.toLowerCase() + (window.location.port!=="443"? ":"+window.location.port : "") + "/class/" + classCode;
  const link = window.location.href;
  const classPath = window.location.pathname;

  const {synchingAssignmentStatuses, assignmentStatuses, studentAssignmentsByClassCode} = useData();
  const assignments = studentAssignmentsByClassCode[studentEnrollment.classCode] || [];
  const nowUtcMs = Date.now();

  const statusByAssignmentId = new Map<string, StudentStatusFromServer>();
  assignmentStatuses
    .filter((status) => status.enrollmentID === studentEnrollment.id)
    .forEach((status) => {
      statusByAssignmentId.set(status.assignmentID, status);
    });

  const completedAssignments = assignments.filter((assignment) => {
    const status = statusByAssignmentId.get(assignment.id || "");
    return status?.status === "complete";
  });

  const activeAssignments = assignments.filter((assignment) => {
    const status = statusByAssignmentId.get(assignment.id || "");
    const availability = getAssignmentAvailability(assignment, nowUtcMs);
    return status?.status === "incomplete" && availability.isOpen;
  });

  const pastDueAssignments = assignments.filter((assignment) => {
    const status = statusByAssignmentId.get(assignment.id || "");
    const availability = getAssignmentAvailability(assignment, nowUtcMs);
    if (status?.status === "complete") {
      return false;
    }
    return availability.isPastDue;
  });

  return <>
    <IonCard>
      <IonCardHeader><IonCardTitle><IonText color="success">Class Login Information</IonText></IonCardTitle></IonCardHeader>
      <IonCardContent>
        <IonList>
          <IonItem>Class Code: {studentEnrollment.classCode}</IonItem>
          <IonItem>Link to Class:&nbsp;<a href={link}>{link}</a></IonItem>
          <IonItem>Student Password:&nbsp;<b>{studentEnrollment.studentPassword}</b></IonItem>
        </IonList>
        <p><IonText color="danger">Please record your login information somewhere and keep it private. There is no way to recover your account if you forget this information.</IonText></p>
      </IonCardContent>
    </IonCard>
    {synchingAssignmentStatuses?
    <IonCard>
      <IonCardHeader><IonCardTitle>Loading Assignments...</IonCardTitle></IonCardHeader>
      <IonCardContent>
        <IonSpinner />
      </IonCardContent>
    </IonCard>
    :
    <>
    <IonCard>
      <IonCardHeader><IonCardTitle>Active Assignments</IonCardTitle></IonCardHeader>
      <IonCardContent>
        {activeAssignments.map((assignment) => {
          const status = statusByAssignmentId.get(assignment.id || "");
          return (
            <div key={assignment.id}>
              <h2><IonText color="primary">{assignment.title || "Assigned Quiz"}</IonText></h2>
              <p>
                <b>Description:</b> {assignment.description || "Take this short quiz to get personal feedback!"}<br/>
                <b>Availability:</b> {formatAssignmentWindow(assignment)}<br/>
                <b>Estimated time to complete:</b>&nbsp;{status?.status === "incomplete" ? status.numRequiredQuestions : "12"} minutes<br/>
                <IonButton routerLink={classPath + "/assignment/" + assignment.id}>Start Assignment</IonButton>
              </p>
            </div>
          );
        })}
        {activeAssignments.length === 0 && <IonText color="medium"><p>No active assignments right now.</p></IonText>}
      </IonCardContent>
    </IonCard>
    <IonCard>
      <IonCardHeader><IonCardTitle>Past Due (Not Completed)</IonCardTitle></IonCardHeader>
      <IonCardContent>
        {pastDueAssignments.map((assignment) => (
          <div key={assignment.id}>
            <h2><IonText color="danger">{assignment.title || "Assigned Quiz"}</IonText></h2>
            <p>
              <b>Description:</b> {assignment.description || "Take this short quiz to get personal feedback!"}<br/>
              <b>Availability:</b> {formatAssignmentWindow(assignment)}<br/>
              <b>Status:</b> Not completed
            </p>
          </div>
        ))}
        {pastDueAssignments.length === 0 && <IonText color="medium"><p>No past-due assignments.</p></IonText>}
      </IonCardContent>
    </IonCard>
    <IonCard>
      <IonCardHeader><IonCardTitle>Completed Assignments</IonCardTitle></IonCardHeader>
      <IonCardContent>
        {completedAssignments.map((assignment) => (
          <div key={assignment.id}>
            <h2><IonText color="primary">{assignment.title || "Assigned Quiz"}</IonText></h2>
            <p>
              <b>Description:</b> {assignment.description || "Take this short quiz to get personal feedback!"}<br/>
              <b>Availability:</b> {formatAssignmentWindow(assignment)}<br/>
              <IonButton routerLink={classPath + "/assignment/" + assignment.id}>See Feedback</IonButton>
            </p>
          </div>
        ))}
        {completedAssignments.length === 0 && <IonText color="medium"><p>No completed assignments yet.</p></IonText>}
      </IonCardContent>
    </IonCard>
    </>
    }

  </>
}

export default ClassOverview;